import { NextTableMetaResponse, NextTableMetaResponseApi } from '../types'

export const nextTableMetaMapper = (meta: NextTableMetaResponseApi): NextTableMetaResponse => {
  return { total: meta.total }
}
